import { scrollToElement, scrollWindowToElement } from 'scroll-element'
import isNull from 'lodash/isNull'

export default class FrontPage {
    constructor() {
        this.cacheDom()
        this.bindEvents()
    }

    cacheDom() {
        this.anchorPoint = document.querySelector('.hero-anchor-point')
    }

    bindEvents() {
        if (!isNull(this.anchorPoint)) {
            this.anchorPoint.addEventListener('click', (e) => {
                e.preventDefault()
                const anchorEl = document.getElementById('how-does-it-work')
                scrollWindowToElement(anchorEl, 500, -100)
            })
        }
    }
}